<button mat-raised-button
        color="primary"
        ngClass.xs="w-100"
        matTooltipPosition="above"
        [matTooltip]="'Gerar Relatório'"
        [matMenuTriggerFor]="menuPrint">
  <mat-icon>print</mat-icon>
  {{label}}
</button>

<mat-menu #menuPrint="matMenu"
          class="rpb">
  <section fxLayout="column">
    <div fxLayout="row"
         class="rpb__title px-2"
         fxLayoutAlign="space-between center">
      <h1>Exportar Relatório</h1>
      <button aria-label="Fechar"
              color="primary"
              mat-mini-fab>
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <div class="rpb__box"
         fxLayout="row"
         fxLayoutAlign="space-between center">
      <span color="primary">
        Selecione um formato para baixar o relatório.
      </span>
    </div>
    <div fxLayout="row"
         fxLayoutAlign="space-around center"
         class="p-3">
      <button aria-label="Exportar PDF"
              color="primary"
              mat-mini-fab
              matSuffix
              matTooltipPosition="above"
              (click)="selectReport(DOWNLOAD_TYPE.PDF)"
              [matTooltip]="'Exportar Relatório em PDF'">
        <mat-icon>picture_as_pdf</mat-icon>
      </button>
      <button aria-label="Exportar Texto"
              color="primary"
              mat-mini-fab
              matSuffix
              matTooltipPosition="above"
              (click)="selectReport(DOWNLOAD_TYPE.TEXT)"
              [matTooltip]="'Exportar Relatório em TEXTO'">
        <mat-icon>text_snippet</mat-icon>
      </button>
      <button aria-label="Exportar Excel"
              color="primary"
              mat-mini-fab
              matSuffix
              matTooltipPosition="above"
              (click)="selectReport(DOWNLOAD_TYPE.EXCEL)"
              [matTooltip]="'Exportar Relatório em Excel'">
        <mat-icon>apps</mat-icon>
      </button>
    </div>
  </section>
</mat-menu>
